import clsx from "clsx";
import { useScaffold } from "../../scaffold";
export type SubtitleProps = React.ComponentProps<"div"> & {
  size?: "md" | "lg";
};
export function Subtitle({
  children,
  className,
  size = "md",
  ...props
}: SubtitleProps) {
  const scaffold = useScaffold();
  return (
    <div
      className={clsx(
        "font-normal text-pretty",
        size === "lg" ? "text-md" : "text-sm",
        scaffold.page.colors.text.tertiary,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
